import http from './http'

/**
 * @description PDF 后台登录
 */
export const apiPdfLogin = function (params) {
  return http.post('/user/login', params)
}

/**
 * @description 请求文件转换
 */
export const apiPdfConvert = function (params) {
  return http.post('/pdfwebbrowser/convert', params)
}

export const apiPdfReportUpload = function (params) {
  return http.post('/pdfwebbrowser/report_upload', params)
}

export const apiPdfStartConvert = function (params) {
  return http.post('/pdfwebbrowser/start_convert', params)
}

export const apiPdfQueryProgress = function (params) {
  return http.post('/pdfwebbrowser/query_progress', params)
}
